module.exports = __webpack_public_path__ + "static/SmashingMagazine-9eb23a4ad6a095119bbe7512faf1ea97.svg";